<template>
    <v-btn
        v-if="purchaseOption"
        @click="$emit('input', purchaseOption)"
        color="dark"
        outlined
        :class="[
            'px-0 avatar-btn',
            $vuetify.breakpoint.width >= 375 ? 'justify-start' : null,
        ]"
        text
        block
    >
        <SoliStatusAvatar
            class="avatar-blue-border"
            :purchaseOption="purchaseOption"
            :event="{}"
            noShadow
            size="55"
            margin="mr-6"
        />
        <div class="flex-col">
            <v-list-item-title
                :class="[
                    'font-bold',
                    $vuetify.breakpoint.width >= 375 ? 'flex' : null,
                ]"
                style="text-transform: none; line-height: 18px"
                >{{
                    purchaseOption.recipient.first_name +
                    "'s " +
                    purchaseOption.name
                }}</v-list-item-title
            >
            <v-list-item-subtitle
                style="text-transform: none; display: flex; line-height: 18px"
                :class="
                    $vuetify.breakpoint.width < 375
                        ? 'justify-center'
                        : 'justify-start'
                "
                >{{
                    `${purchaseOption.location.name}
                    ${
                        purchaseOption.category == "drop-ins" &&
                        purchaseOption.passes
                            ? " | " + purchaseOption.passes + " remaining"
                            : ""
                    }`
                }}
            </v-list-item-subtitle>
        </div>
    </v-btn>
</template>

<script>
export default {
    props: {
        purchaseOption: {
            type: Object,
            default: () => {},
        },
    },
};
</script>

<style></style>
